import { Button } from "@/components/ui/button";

export function WhatsAppFloatingButton() {
  // Component removed - functionality moved to FixedContactButton
  return null;
}
